import { HTMLAttributes, ReactElement, useState } from 'react'
import { DisplayProps, MarginProps } from 'styled-system'

import { GapProps, TestIdProps } from 'designSystem/types/propTypes'

import { FlexBoxProps } from 'components/common/FlexBox/FlexBox'
import INTERNALxDiv from 'designSystem/components/internal/elements/INTERNALxDiv'
import { COLOR } from 'designSystem/foundations/constants/color'
import { SIZE } from 'designSystem/foundations/constants/size'

import PDSIconButton from '../PDSIconButton/PDSIconButton'

type BaseProps = HTMLAttributes<HTMLDivElement> &
  DisplayProps &
  GapProps &
  FlexBoxProps &
  MarginProps &
  TestIdProps

export type BannerVariant = 'action' | 'alert' | 'info' | 'warning'

type Props = {
  variant: BannerVariant
  showClose?: boolean
  fullBorder?: boolean
} & BaseProps

export default function PDSBanner({
  children,
  showClose,
  testId,
  variant,
  fullBorder,
  ...props
}: Props): ReactElement | null {
  let [showBanner, setShowBanner] = useState(true)

  let backgroundColor: string = COLOR.feedbackAction
  let borderColor: string = COLOR.feedbackAction_border
  switch (variant) {
    case 'action':
      backgroundColor = COLOR.feedbackAction
      borderColor = COLOR.feedbackAction_border
      break
    case 'alert':
      backgroundColor = COLOR.alert100
      borderColor = COLOR.alert400
      break
    case 'info':
      backgroundColor = COLOR.info100
      borderColor = COLOR.info400
      break
    case 'warning':
      backgroundColor = COLOR.warning100
      borderColor = COLOR.warning400
      break
  }

  const hideBanner = () => setShowBanner(false)

  if (showBanner) {
    return (
      <INTERNALxDiv
        alignItems="center"
        backgroundColor={backgroundColor}
        border={fullBorder ? `1px solid ${borderColor}` : undefined}
        borderBottom={fullBorder ? undefined : `1px solid ${borderColor}`}
        display="flex"
        gap={SIZE.s8}
        padding={`${SIZE.s8} ${SIZE.s36}`}
        testId={testId}
        borderRadius={fullBorder ? SIZE.s4 : undefined}
        {...props}
      >
        <INTERNALxDiv flex={1}>{children}</INTERNALxDiv>
        {showClose && (
          <INTERNALxDiv>
            <PDSIconButton name="close" onClick={hideBanner} />
          </INTERNALxDiv>
        )}
      </INTERNALxDiv>
    )
  } else {
    return null
  }
}
